import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
import { Button } from './ui/button';

const Header = () => {
  const { language, toggleLanguage } = useLanguage();
  const location = useLocation();
  const t = translations[language];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* RCMP Logo and Bilingual Name */}
          <Link to="/" className="flex items-center space-x-3">
            {/* RCMP Crest */}
            <img 
              src="/images/rcmp-logo.png" 
              alt="RCMP Crest" 
              className="h-12 w-auto"
            />
            {/* Bilingual Text */}
            <div className="flex items-center">
              <div className="text-gray-900">
                <div className="text-sm font-semibold leading-tight">Royal Canadian</div>
                <div className="text-sm font-semibold leading-tight">Mounted Police</div>
              </div>
              <div className="mx-3 h-8 w-px bg-gray-300"></div>
              <div className="text-gray-900">
                <div className="text-sm font-semibold leading-tight">Gendarmerie royale</div>
                <div className="text-sm font-semibold leading-tight">du Canada</div>
              </div>
            </div>
          </Link>

          {/* Navigation Links */}
          <nav className="hidden md:flex items-center space-x-1">
            <Link 
              to="/" 
              className={`px-4 py-2 text-sm font-medium transition-colors rounded-md ${
                isActive('/') 
                  ? 'text-blue-600 bg-blue-50' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
              }`}
            >
              {t.home}
            </Link>
            <Link 
              to="/register" 
              className={`px-4 py-2 text-sm font-medium transition-colors rounded-md ${
                isActive('/register') 
                  ? 'text-blue-600 bg-blue-50' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
              }`}
            >
              {t.register}
            </Link>
            <Link 
              to="/faq" 
              className={`px-4 py-2 text-sm font-medium transition-colors rounded-md ${
                isActive('/faq') 
                  ? 'text-blue-600 bg-blue-50' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
              }`}
            >
              {t.faq}
            </Link>
            <Link 
              to="/disclaimer" 
              className={`px-4 py-2 text-sm font-medium transition-colors rounded-md ${
                isActive('/disclaimer') 
                  ? 'text-blue-600 bg-blue-50' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
              }`}
            >
              {t.disclaimer}
            </Link>
            <Link 
              to="/admin" 
              className={`px-4 py-2 text-sm font-medium transition-colors rounded-md ${
                isActive('/admin') || isActive('/admin-dashboard')
                  ? 'text-blue-600 bg-blue-50' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
              }`}
            >
              {t.adminLogin}
            </Link>
          </nav>

          {/* Language Toggle */}
          <Button
            variant="outline"
            size="sm"
            onClick={toggleLanguage}
            className="font-medium text-gray-700 border-gray-300 hover:bg-gray-50"
          >
            {language === 'en' ? 'Français' : 'English'}
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
